import React from 'react'
import AnimatedText6 from './AnimatedText6'
import iconorange from '../images/icon_orange.svg';
import redcan1 from '../images/redcan1.webp';
import redcan2 from '../images/redcan2.png';

const BeforeAfterSection = () => {
    const handleScroll = (elementId) => {
        const element = document.getElementById(elementId);
        
        if (element) {
            // Calculate the header height or default to 80 if header isn't found
            const header = document.querySelector('.header');
            const offset = header ? header.offsetHeight : 80;
            
            // Get the element's position relative to the viewport
            const elementPosition = element.getBoundingClientRect().top;
        
            // Check for mobile view (e.g., screen width <= 768px) and adjust scroll behavior
            if (window.innerWidth <= 768) {
                // For mobile, scroll to the element just below the header
                const offsetPosition = elementPosition + window.pageYOffset - 100;
        
                // Scroll smoothly to the calculated position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            } else {
                // For desktop, keep the default behavior (scrolling to the element with an offset)
                const offsetPosition = elementPosition + window.pageYOffset - offset;
        
                // Scroll smoothly to the calculated position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        }
    };
  return (
    <div>
         <section id="before-after">
                <div className='container-xxl before-container'>
                    <div className='row before-row'>
                        <div className='col-md-6 colleft'>
                            <div className='subbefore'>
                                <div className='firstb'>
                                    <p>Before</p>
                                    <div className='imgbox'>
                                        <picture className='picturediv'>
                                            <source
                                                src={redcan1}
                                                width="820px"
                                                media="(max-width: 640px)"
                                            />
                                            <source
                                                src={redcan1}
                                                width="1024px"
                                                media="(min-width: 641px) and (max-width: 820px)"
                                            />
                                            <source
                                                src={redcan1}
                                                width="1800px"
                                                media="(min-width: 821px) and (max-width: 1024px)"
                                            />
                                            <source
                                                src={redcan1}
                                                width="2048px"
                                                media="(min-width: 1025px)"
                                            />
                                            <img
                                                src={redcan1}
                                                alt="Non-alcoholic Bubbly Red can by Surely, displayed with product details and price."
                                                loading="eager"
                                                className='mainimg'
                                            />
                                        </picture>

                                    </div>
                                </div>
                                <div className='secondb'>
                                    <p>After</p>
                                    <div className='imgbox'>
                                        <picture className='picturediv'>
                                            <source
                                                src={redcan2}
                                                width="820px"
                                                media="(max-width: 640px)"
                                            />
                                            <source
                                                src={redcan2}
                                                width="500px"
                                                media="(min-width: 641px) and (max-width: 820px)"
                                            />
                                            <source
                                                src={redcan2}
                                                width="1800px"
                                                media="(min-width: 821px) and (max-width: 1024px)"
                                            />
                                            <source
                                                src={redcan2}
                                                width="2048px"
                                                media="(min-width: 1025px)"
                                            />
                                            <img
                                                className='mainimg'
                                                src="https://cdn.shopify.com/s/files/1/0585/1034/4281/files/13_Pro_-_424_f35f2c2d-de59-4528-9bf2-df32fd6fb692.png?v=1722781486"
                                                alt="Non-Alcoholic Bubbly Red Can 4-Pack product listing with price, reviews, and nutritional information."

                                                loading="eager"
                                            />
                                        </picture>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 colright'>
                            <div className='content'>
                                <div className='first' data-aos="fade-up" data-aos-once="true">
                                    <img id="workimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                                    <p>Our Work</p>
                                </div>

                                <AnimatedText6 />
                                <p className='rightp'
                                >We realised there’s too much to showcase in one small space. That’s why we invite you to book a call with us and explore our portfolio firsthand. Discover how we’ve helped brands like yours grow and succeed with tailored solutions.</p>
                                <button className='btntest' onClick={()=>handleScroll('client')}
                                >
                                    <p className='mb-0'>See Testimonials</p>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    </div>
  )
}

export default BeforeAfterSection